@if (generalProblem !== '') {
  <div>
    <div class="card" style="margin: 1ex; padding: 1ex">
      <h2>{{applicationTitle}}</h2>
      <p [innerHTML]="generalProblem"></p>
    </div>
  </div>
}
@if ((!applicationSuccessful) && generalProblem === '') {
  <div>
    <div class="card" style="margin: 1ex; padding: 1ex">
      <h2>{{applicationTitle}}</h2>
    </div>
    @if (!splitApplicationForm||page===0) {
      <div>
        @if (titleMessage != '') {
          <div class="card" style="margin: 1ex; padding: 1ex" [innerHTML]="titleMessage"></div>
        }
        <div class="card" style="margin: 1ex; padding: 1ex">
          <h3 id="kontaktdaten">Kontaktdaten</h3>
          <div class="applicationform">
            @if (showSalutationField) {
              <label id="salutationLabel" for="salutation">Anrede*</label>
              <p-select inputId="salutation" [options]="['Divers','Frau','Herr']" placeholder="Bitte wählen" [(ngModel)]="salutation" class="fullWidth"> </p-select>
              <div class="w-full mb-2"></div>
            }
            <label id="firstnameLabel" for="firstname">Vorname*</label>
            <input id="firstname" type="text" pInputText [(ngModel)]="firstname">
            <div class="w-full mb-2"></div>
            <label id="lastnameLabel" for="lastname">Nachname*</label>
            <input id="lastname" type="text" pInputText [(ngModel)]="lastname">
            <div class="w-full mb-2"></div>
            <label id="emailLabel" for="email">E-Mail*</label>
            <input id="email" type="text" pInputText [(ngModel)]="email">
            <div class="w-full mb-2"></div>
            <label id="emailRepeatedLabel" for="emailRepeated">E-Mail bestätigen*</label>
            <input id="emailRepeated" type="text" pInputText [(ngModel)]="emailRepeated">
            <div class="w-full mb-2"></div>
            <div id="additionalFields">
              @for (field of additionalFieldsConfig; track field; let i = $index) {
                <div class="applicationform">
                  @if (field.required) {
                    <label>{{field.label}}*</label>
                  }
                  @if (!field.required) {
                    <label>{{field.label}}</label>
                  }
                  @if (field.selectableValues.length === 0 && field.type === 'STRING') {
                    <input type="text" pInputText [maxLength]="field.lengthLimit" [(ngModel)]="additionalFields[i].values[0]">
                  }
                  @if (field.selectableValues && field.multiSelect) {
                    <div class="applicationform">
                      @for (selectable of field.selectableValues; track selectable; let j = $index) {
                        <div class="flex align-items-center">
                          <p-checkbox [inputId]="field.id + '_' + j" [name]="field.id" [value]="selectable" [(ngModel)]="additionalFields[i].values"></p-checkbox>
                          <label [for]="field.id + '_' + j" class="ml-2">{{selectable}}</label>
                        </div>
                      }
                      @if (field.selectShowOther) {
                        <div class="flex align-items-center">
                          <p-checkbox inputId="other_{{field.id}}" [name]="field.id" [value]="sentinalNullValue" [(ngModel)]="additionalFields[i].values"></p-checkbox>
                          <label for="other_{{field.id}}" class="ml-2">Sonstiges:</label>
                          <input type="text" pInputText [disabled]="!additionalFields[i].hasSentinalValue" [maxLength]="field.lengthLimit" [(ngModel)]="additionalFields[i].selectOtherField" style="flex: 1; max-width: 300px;" class="ml-2">
                        </div>
                      }
                    </div>
                  }
                  @if (field.selectableValues && !field.multiSelect) {
                    <div class="applicationform">
                      @for (selectable of field.selectableValues; track selectable; let j = $index) {
                        <div class="flex align-items-center">
                          <p-radioButton [inputId]="field.id + '_' + j" [name]="field.id" [value]="selectable" [(ngModel)]="additionalFields[i].values[0]"></p-radioButton>
                          <label [for]="field.id + '_' + j" class="ml-2">{{selectable}}</label>
                        </div>
                      }
                      @if (field.selectShowOther) {
                        <div class="flex align-items-center">
                          <p-radioButton inputId="other_{{field.id}}" [name]="field.id" [value]="sentinalNullValue" [(ngModel)]="additionalFields[i].values[0]"></p-radioButton>
                          <label for="other_{{field.id}}" class="ml-2">Sonstiges:</label>
                          <input type="text" pInputText [disabled]="!additionalFields[i].hasSentinalValue" [maxLength]="field.lengthLimit" [(ngModel)]="additionalFields[i].selectOtherField" style="flex: 1; max-width: 300px;" class="ml-2">
                        </div>
                      }
                    </div>
                  }
                  @if (field.type === 'DATE') {
                    <input pInputText type="date" [(ngModel)]="additionalFields[i].values[0]" />
                  }
                  @if (field.type === 'INTEGER') {
                    <p-inputNumber [min]="field.minValue" [max]="field.maxValue" [(ngModel)]="additionalFields[i].values[0]" />
                  }
                  @if (field.type === 'BOOLEAN') {
                    <div class="flex align-items-center">
                      <p-checkbox inputId="bool_{{field.id}}" [name]="field.id" [binary]="true" [(ngModel)]="additionalFields[i].values[0]"></p-checkbox>
                      <label for="bool_{{field.id}}" class="ml-2" [innerHTML]="field.checkboxLabel??''"></label>
                    </div>
                  }
                  <div class="w-full mb-2"></div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (!splitApplicationForm||page===1) {
      <div>
        @if (bookingMessage != '') {
          <div class="card" style="margin: 1ex; padding: 1ex" [innerHTML]="bookingMessage"></div>
        }
        <div class="card" style="margin: 1ex; padding: 1ex;">
          <h3 id="veranstaltungen">Veranstaltungen</h3>
          <p>Such dir deine Veranstaltungen aus{{rules.length == 0 ? '' : ' und beachte folgende Regeln'}}:</p>
          @if (rules.length > 0) {
            <ul>
              @for (rule of rules; track rule) {
                <li>
                  <span [innerHTML]="rule.text"></span>
                  @if (rule.validated) {
                    <span style="color: darkgreen"> (Erfüllt)</span>
                  }
                  @if (!rule.validated) {
                    <span style="color: firebrick"> (Noch nicht erfüllt)</span>
                  }
                </li>
              }
            </ul>
          }
          <div class="pb-3">
            <div class="flex flex-column sm:flex-row gap-2 align-items-center">
              <div class="flex-grow-1">
                <input pInputText id="search" type="text" [(ngModel)]="searchTerm" (ngModelChange)="filter()"
                  placeholder="Suche..." class="w-full" style="height: 2.625rem;" />
              </div>
              @if (groupedByOptions && groupedByOptions.length > 1) {
                <div class="flex flex-column sm:flex-row gap-2 align-items-center">
                  <label for="sort" class="mb-0">Gruppieren nach:</label>
                  <p-select styleClass="w-full sm:w-auto" inputId="sort" [options]="groupedByOptions"
                    [ngModel]="groupedBy" (ngModelChange)="changeGrouping($event)" optionLabel="label"
                  optionValue="value"></p-select>
                </div>
              }
              @if (tagCategories.length > 0) {
                <p-button type="button" label="Filter" icon="pi pi-filter" (click)="showTags = true;"
                styleClass="p-button-secondary big-filter sm:inline-flex hidden" [style]="{'height': '2.625rem'}" ariaLabel="Filter"></p-button>
                <p-button type="button" icon="pi pi-filter" (click)="showTags = true;" styleClass="p-button-secondary p-button-rounded p-button-raised sm:hidden fixed-button" ariaLabel="Filter"></p-button>
              }
            </div>
              @if (allSelectedTags.length > 0) {
                <div class="flex flex-row flex-wrap align-items-center sm:gap-2 pt-2">
                  <div>Ausgewählte Filter:</div>
                  @for (tag of allSelectedTags; track tag) {
                    <p-chip (click)="selectTag(tag)" styleClass="selected">
                      {{tags[tag].text}} <i class="pi pi-times-circle pl-2"></i>
                    </p-chip>
                  }
                  <p-button type="button" (click)="removeAllFilters()" [style]="{ 'line-height': '1.5', 'border-color': '#c8c8c8' }"
                    styleClass="p-button-secondary p-button-rounded selected-filters cursor-pointer"
                  icon="pi pi-filter-slash" pTooltip="Alle Filter aufheben" ariaLabel="Alle Filter aufheben"></p-button>
                </div>
              }
            </div>
            @if (groupedTimetable.length > 1) {
              <div id="accordionView">
                <p-accordion [multiple]="true">
                  @for (entry of groupedTimetable; track entry; let i = $index) {
                    <p-accordion-panel [value]="i">
                      <p-accordion-header>
                        @for (groupedBy of entry.groupedBy; track groupedBy; let last = $last) {
                          <div>
                            @if (groupedByType(groupedBy)==='Date') {
                              <span>{{$any(groupedBy)|localizedDate:'E, dd.MM.yyyy'}}</span>
                            }
                            @if (groupedByType(groupedBy)==='Time') {
                              <span>{{$any(groupedBy)|time}}</span>
                            }
                            @if (groupedByType(groupedBy)==='Timeslot') {
                              <span>
                                {{$any(groupedBy).date|localizedDate:'E, dd.MM.yyyy'}} {{$any(groupedBy).start|time}} - {{$any(groupedBy).end|time}}
                              </span>
                            }
                            @if (groupedByType(groupedBy)==='string') {
                              <span>{{groupedBy}}</span>
                            }
                            @if (groupedByType(groupedBy)==='undefined') {
                              <span>Allgemein</span>
                            }
                            @if (!last) {
                              <span style="white-space: pre"> | </span>
                            }
                          </div>
                        }
                      </p-accordion-header>
                      <p-accordion-content>
                        <p-table class="table" [value]="entry.entries" breakpoint="640px">
                        <ng-template pTemplate="header">
                          <tr>
                            <th scope="col" style="width: 40px;"></th>
                            <th scope="col">Veranstaltung</th>
                            <th scope="col">Zeit</th>
                            <th scope="col">Ort</th>
                            <th scope="col" style="width: 6em;">Freie Plätze</th>
                            @if (showTypeInTable) {
                              <th scope="col">Typ</th>
                            }
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-i>
                          <tr [class.overbooked]="isOverbooked(i)" [ngClass]="{'striped-color':i.timeslotCount!%2!==0}" (click)="toggleSelection(i)">
                            <td class="selection">
                              @if (canSelectEntry(i)) {
                                <p-checkbox [(ngModel)]="i.selected" [binary]="true" (onChange)="updateRules()" (click)="stopEvent($event)"></p-checkbox>
                              }
                            </td>
                            <td>
                              <div class="flex flex-column align-items-start">
                                @if (i.entry.subtitle) {
                                  <div class="subtitleRow">{{i.entry.subtitle|addZeroWidthSpace}}</div>
                                }
                                <div>{{ i.entry.title|addZeroWidthSpace}}</div>
                                @if (i.entry.furtherInformationUrl) {
                                  <div>
                                    <a target="_blank" href="{{linkFormat(i.entry.furtherInformationUrl)}}" class="external">Weitere Informationen</a>
                                  </div>
                                }
                              </div>
                            </td>
                            <td>
                              <div class="flex flex-column align-items-start">
                                <edu-udo-itmc-dev-mini-book-date-display [date]="i.timeslot.date"></edu-udo-itmc-dev-mini-book-date-display>
                                <div>
                                  <edu-udo-itmc-dev-mini-book-time-display [time]="i.timeslot.start"></edu-udo-itmc-dev-mini-book-time-display>
                                  -
                                  <edu-udo-itmc-dev-mini-book-time-display [time]="i.timeslot.end"></edu-udo-itmc-dev-mini-book-time-display>
                                </div>
                              </div>
                            </td>
                            <td class="hide-on-small-screen">
                              <edu-udo-itmc-dev-mini-book-room-display [room]="i.room" [online]="i.entry.online"></edu-udo-itmc-dev-mini-book-room-display>
                            </td>
                            <td>
                              @if (i.entry.type != 'BREAK' && i.entry.attendeeCount != undefined && i.entry.maxAttendees > 0) {
                                <span>{{(i.entry.maxAttendees - i.entry.attendeeCount)<0?0:(i.entry.maxAttendees - i.entry.attendeeCount)}}</span>
                              }
                              @if (i.entry.type != 'BREAK' && i.entry.attendeeCount != undefined && i.entry.maxAttendees == 0) {
                                <span>unbegr.</span>
                              }
                            </td>
                            @if (showTypeInTable) {
                              <td>
                                {{i.entry.type|translate}}
                              </td>
                            }
                          </tr>
                        </ng-template>
                      </p-table>
                      </p-accordion-content>
                    </p-accordion-panel>
                  }
                </p-accordion>
              </div>
            }
            @if (groupedTimetable.length === 1) {
              <div id="normalView">
                <p-table class="table" [value]="groupedTimetable[0].entries" breakpoint="640px">
                  <ng-template pTemplate="header">
                    <tr>
                      <th scope="col" style="width: 40px;"></th>
                      <th scope="col">Veranstaltung</th>
                      <th scope="col">Zeit</th>
                      <th scope="col">Ort</th>
                      <th scope="col" style="width: 6em;">Freie<br>Plätze</th>
                      @if (showTypeInTable) {
                        <th scope="col">Typ</th>
                      }
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-i>
                    <tr [class.overbooked]="isOverbooked(i)" [ngClass]="{'striped-color':i.timeslotCount!%2!==0}" (click)="toggleSelection(i)">
                      <td class="selection">
                        @if (canSelectEntry(i)) {
                          <p-checkbox [(ngModel)]="i.selected" [binary]="true" (onChange)="updateRules()" (click)="stopEvent($event)"></p-checkbox>
                        }
                      </td>
                      <td>
                        <div class="flex flex-column align-items-start">
                          @if (i.entry.subtitle) {
                            <div class="subtitleRow">{{i.entry.subtitle|addZeroWidthSpace}}</div>
                          }                          
                          <div>{{i.entry.title|addZeroWidthSpace}}</div>
                          @if (i.entry.furtherInformationUrl) {
                            <div>
                              <a target="_blank" href="{{linkFormat(i.entry.furtherInformationUrl)}}" class="external">Weitere Informationen</a>
                            </div>
                          }
                        </div>
                      </td>
                      <td>
                        <div class="flex flex-column align-items-start">
                          <edu-udo-itmc-dev-mini-book-date-display [date]="i.timeslot.date"></edu-udo-itmc-dev-mini-book-date-display>
                          <div>
                            <edu-udo-itmc-dev-mini-book-time-display [time]="i.timeslot.start"></edu-udo-itmc-dev-mini-book-time-display>
                            -
                            <edu-udo-itmc-dev-mini-book-time-display [time]="i.timeslot.end"></edu-udo-itmc-dev-mini-book-time-display>
                          </div>
                        </div>
                      </td>
                      <td class="hide-on-small-screen">
                        <edu-udo-itmc-dev-mini-book-room-display [room]="i.room" [online]="i.entry.online"></edu-udo-itmc-dev-mini-book-room-display>
                      </td>
                      <td>
                        @if (i.entry.type != 'BREAK' && i.entry.attendeeCount != undefined && i.entry.maxAttendees > 0) {
                          <span>{{(i.entry.maxAttendees - i.entry.attendeeCount)<0?0:(i.entry.maxAttendees - i.entry.attendeeCount)}}</span>
                        }
                        @if (i.entry.type != 'BREAK' && i.entry.attendeeCount != undefined && i.entry.maxAttendees == 0) {
                          <span>unbegr.</span>
                        }
                      </td>
                      @if (showTypeInTable) {
                        <td>
                          {{i.entry.type|translate}}
                        </td>
                      }
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }
            @if (groupedTimetable.length ===0) {
              <div>
                Für Ihre Suche wurde keine Veranstaltung gefunden.
              </div>
            }
          </div>
          @if (selectedTimetableEntries.length >= 1) {
            <div class="card" style="margin: 1ex; padding: 1ex; min-width: fit-content;">
              <h3>Stundenplan</h3>
              <edu-udo-itmc-dev-mini-book-timetable-display [entries]="selectedTimetableEntries">
              </edu-udo-itmc-dev-mini-book-timetable-display>
            </div>
          }
          @if (privacyPolicyText&&privacyPolicyUrl) {
            <div class="card" style="margin: 1ex; padding: 1ex">
              <h3>Datenschutzvereinbarung</h3>
              <div class="flex gap-2">
                <p-checkbox inputId="privacyPolicy" [(ngModel)]="privacyPolicyChecked" [binary]="true" styleClass="mt-2"></p-checkbox>
                <label for="privacyPolicy" class="mt-2">{{privacyPolicyText}}*</label>
              </div>
              <div>Zur <a href="{{linkFormat(privacyPolicyUrl)}}" class="external" target="_blank">Datenschutzvereinbarung</a></div>
            </div>
          }
        </div>
      }
      <div class="card" style="margin: 1ex; padding: 1ex">
        <edu-udo-itmc-dev-mini-book-error-renderer [errors]="errors">
        </edu-udo-itmc-dev-mini-book-error-renderer>
        <div class="button-row">
          @if (!splitApplicationForm||page===1) {
            <p-button (click)="submit()" label="Anmelden" icon="pi pi-check" [loading]="requestRunning" [disabled]="!!privacyPolicyUrl&&!privacyPolicyChecked" ariaLabel="Anmelden"></p-button>
          }
          @if (splitApplicationForm&&page===1) {
            <p-button (click)="goToPage0()" label="Zurück" icon="pi pi-arrow-left" iconPos="left" ariaLabel="Zurück"></p-button>
          }
          @if (splitApplicationForm&&page===0) {
            <p-button (click)="goToPage1()" label="Weiter" icon="pi pi-arrow-right" iconPos="right" ariaLabel="Weiter"></p-button>
          }
        </div>
      </div>
      <div class="card" style="margin: 1ex; padding: 1ex">
        * markierte Felder sind Pflichtfelder
      </div>
    </div>
  }
  @if (applicationSuccessful) {
    <div>
      <div class="card" style="margin: 1ex; padding: 1ex">
        <h2>Vielen Dank für die Anmeldung!</h2>
        <div [innerHTML]="applicationSuccessfulMessage"></div>
      </div>
    </div>
  }
  @if (tagCategories.length > 0) {
    <p-drawer [(visible)]="showTags" position="right" styleClass="w-full md:w-6 xl:w-4"
      id="filter-sidebar" class="filter-sidebar" [modal]="false">
      <h2 class="mb-3">Filter:</h2>
      <div class="flex flex-column gap-2">
        @for (cat of tagCategories; track cat) {
          <div>
            <h3 class="text-base">{{cat.label}}:</h3>
            <div class="flex flex-wrap align-items-baseline gap-2">
              @for (tagId of cat.tagIds; track tagId) {
                <p-chip (click)="selectTag(tagId)"
                  [styleClass]="allSelectedTags.includes(tagId)?'selected':''">
                  {{tags[tagId].text}}
                </p-chip>
              }
            </div>
          </div>
        }
        <div class="mt-4 flex justify-content-between">
          <p-button (click)="showTags = false;" styleClass="line-height-1"
          [label]="allSelectedTags.length > 0?'Filter anwenden':'Schließen'" ariaLabel="Filter schließen"></p-button>
          @if (allSelectedTags.length>0) {
            <p-button (click)="removeAllFilters()" styleClass="p-button-secondary line-height-1"
            icon="pi pi-filter-slash" label="Alle Filter aufheben" ariaLabel="Alle Filter aufheben"></p-button>
          }
        </div>
      </div>
    </p-drawer>
  }